import { makeAuthHeaders } from "../oauth/auth";

export const fetchSqlCreativesByIds = async (creativeIds) => {
  if (!creativeIds || creativeIds.length === 0) return [];

  const BATCH_SIZE = 200;
  const allResults = [];
  const headers = await makeAuthHeaders();

  for (let i = 0; i < creativeIds.length; i += BATCH_SIZE) {
    const batch = creativeIds.slice(i, i + BATCH_SIZE);
    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL +
          `/api/sql/creatives?creativeIds=${batch.toString()}`,
        { method: "GET", headers }
      );
      if (!response.ok) throw new Error(`SQL creatives fetch failed: ${response.status}`);
      const data = await response.json();
      if (data && data.length > 0) allResults.push(...data);
    } catch (error) {
      console.log("An error occurred fetching SQL creatives.", error);
    }
  }

  return allResults;
};
